import React, { useState, useEffect, useRef, useCallback } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import { useForm, Controller } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { SelectButton } from 'primereact/selectbutton';
import { Calendar } from 'primereact/calendar';
import { InputSwitch } from 'primereact/inputswitch';
import { Tag } from 'primereact/tag';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SignaturePad from '../signature/SignaturePad';
import { faBackward, faBarcode } from '@fortawesome/free-solid-svg-icons';
import { classNames } from 'primereact/utils';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';
import PugiService from '../../service/PugiService';
import LocationService from '../geolocator/LocationService';
import MMInfo from '../mm/MMInfo';
import MmSelect from '../mm/MmSelect';
import { QrScaner } from '../../utilities/QrScaner';
import { CanAccess, StartButton, EndButton } from '../permissions';
import { usePermissions } from '../../hooks/usePermissions';
import MmService from '../../service/MmService';
import { useRvp, useNi, useSi, useTipTrosila, useMarkaTrosila } from '../../store/index';
// import { useStatus } from '../../store/index'; // removed unused statuss
// import { useUsers } from '../../store/index';
// import { useGroups } from '../../store/index';
import moment from 'moment';
import { useYupValidationResolver } from '../../utilities/useYupValidationResolver';
import * as yup from 'yup';
import i18n from '../../i18n';
// removed unused import 'use'

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;
const validationSchema = yup.object().shape({
    mm_id: yup.string().required('mm_id is required.'),

    vp: yup.boolean().required('vp is required.'),

    status_id: yup.string().required('status_id is required.'),

    potrosac_nije_kuci: yup.boolean().required('potrosac_nije_kuci is required.'),

    emailAddress: yup.string().when('poslati_izvestaj_email', {
        is: true,
        then: (schema) => schema.email('Email adresa nije validna.').required('Email adresa je obavezna.'),
        otherwise: (schema) => schema.notRequired()
    })
});
// translation with parameters

// Aca , Ivan, Nikola

const storage = process.env.REACT_APP_STORAGE_URL || 'http://localhost:8000/storage/';

function PugiStepsForm() {
    const [model, setModel] = useState({});
    const [deleteModelDialog, setDeleteModelDialog] = useState(false);
    const [mmSelectDialog, setMmSelectDialog] = useState(false);
    const [signatureDialog, setSignatureDialog] = useState(false);
    const [actionType, setActionType] = useState('');
    const [showQrScaner, setShowQrScaner] = useState(false);
    const [scannerMode, setScannerMode] = useState(''); // 'mm' or 'broj_merila'
    const scannerModeRef = useRef(''); // Ref za praćenje scannerMode u callback-ovima
    const [activeIndex, setActiveIndex] = useState(0); // multi-step index
    const [saving, setSaving] = useState(false); // auto-save state
    const [finishing, setFinishing] = useState(false); // full-screen finish/email sending state
    const [previewDialog, setPreviewDialog] = useState({ visible: false, file: null });
    const [previewNumPages, setPreviewNumPages] = useState(0);
    const [previewError, setPreviewError] = useState(null);
    const [pdfScale, setPdfScale] = useState(1);
    const previewContainerRef = useRef(null);
    const [previewWidth, setPreviewWidth] = useState(600);
    const [pendingScanSnapshot, setPendingScanSnapshot] = useState(null);
    const [snapshotCacheKey, setSnapshotCacheKey] = useState(Date.now());
    const gatingWarnShown = useRef(false);
    const initialLoadDone = useRef(false);

    const previewFileUrl = typeof previewDialog.file === 'string' ? previewDialog.file : previewDialog.file?.url;

    // Sinhronizuj ref sa state-om
    useEffect(() => {
        scannerModeRef.current = scannerMode;
    }, [scannerMode]);

    const toast = useRef(null);
    const navigate = useNavigate();

    const { id } = useParams(); // Uzimanje parametara iz URL-a

    // set default values for form - trebam da vidim originalne defaultne vrednosti
    const defaultValues = {
        mm_id: '',
        mm: null,
        datum_provere: moment().format('YYYY-MM-DD'),
        vp: false,
        rvp_id: '',
        ostecen: false,
        funkcionalan: true,
        nepropustan: true,
        ni_id: 2,
        potrebna_intervencija: false,
        komentar_intervencije: '',
        broj_kontrole_kotla: '',
        datum_kontrole_kotla: '',
        saniran_problem: false,
        datum_sanacije: '',
        komentar_sanacije: '',
        ispravna_instalacija: true,
        potpis_ime_prezime: '',
        potpis_url: '',
        slika_projekta_url: '',
        status_id: 1,
        si_id: 3,
        tip_trosila_id: 1,
        marka_trosila_id: '',
        snaga_trosila: '',
        potrosac_nije_kuci: false,
        pocetak_provere: '',
        kraj_provere: '',
        kreirao_rn_users_id: '',
        uradio_pugi_users_id: '',
        dodeljen_users_id: '',
        dodeljen_groups_id: '',
        dodeljen_datum: '',
        pp_id: 2,
        // Nova polja za prošireni PUGI formular
        izvedeno_odgovara_projektu: true,
        pritisak_gasa: '22',
        vodjenje_instalacije: 'spolja',
        materijal_instalacije: ['Cu'],
        nosaci_ispravni: true,
        zaporni_organi_ispravni: true,
        fleksibilne_veze_ispravne: true,
        premoscenje_potencijala: true,
        dimnjak: false,
        dimnjak_datum_ciscenja: '',
        telefon_korisnika_pugi: '',
        broj_merila_pugi: '',
        emailAddress: '',
        poslati_izvestaj_email: false,
        poslati_izvestaj_postom: false,
        stranka_ne_omogucava_pregled: false,
        stranka_nece_da_potpise: false,
        tip_trosila_ids: [1]
    };

    const { getPugi, deletePugi, createPugi, updatePugi, startPugi, endPugi, pdfPugi, uploadImage, uploadSignatureImage, nijeKodKuce, neOmogucavaPregled } = PugiService();

    // related models values

    // removed unused fileUploadRef (no direct image upload in steps now)

    const { tipTrosilas } = useTipTrosila((state) => ({ tipTrosilas: state.tipTrosilas }));
    const { markaTrosilas } = useMarkaTrosila((state) => ({ markaTrosilas: state.markaTrosilas }));
    const { rvps } = useRvp((state) => ({ rvps: state.rvps }));
    const { nis } = useNi((state) => ({ nis: state.nis }));
    // removed: const { statuss } = useStatus((state) => ({ statuss: state.statuss }));
    const { sis } = useSi((state) => ({ sis: state.sis }));
    // removed unused users & groups store consumers

    const resolver = useYupValidationResolver(validationSchema);
    const { getMmsLazy } = MmService();

    const {
        control,
        formState: { errors, isDirty },
        handleSubmit,
        setValue,
        watch,
        reset,
        getValues
    } = useForm({
        defaultValues,
        resolver,
        mode: 'onChange'
    });

    const mmSelected = watch('mm');

    // Helper function to format date fields to YYYY-MM-DD before sending to server
    const formatDateFields = (data) => {
        const dateFields = ['dimnjak_datum_ciscenja', 'datum_kontrole_kotla', 'datum_sanacije', 'dodeljen_datum'];
        const formatted = { ...data };
        // Ne šaljemo datum_provere - server ga postavlja automatski pri startovanju provere
        delete formatted.datum_provere;

        dateFields.forEach((field) => {
            if (formatted[field]) {
                // If it's already a string in correct format, keep it; otherwise format it
                const dateValue = formatted[field];
                if (dateValue instanceof Date || (typeof dateValue === 'string' && dateValue.includes('T'))) {
                    formatted[field] = moment(dateValue).format('YYYY-MM-DD');
                }
            }
        });
        return formatted;
    };

    const resolveUgiSkicaUrl = (mmData) => {
        if (!mmData) {
            return null;
        }

        if (mmData.ugi_skica_url) {
            return mmData.ugi_skica_url;
        }

        if (mmData.ugi_skica_path) {
            return `${storage}${mmData.ugi_skica_path}`;
        }

        return null;
    };

    const resolveStorageUrl = (path) => {
        if (!path) {
            return null;
        }

        if (/^https?:\/\//i.test(path)) {
            return path;
        }

        return `${storage}${path}`;
    };

    const scanSnapshotPath = watch('slika_projekta_url') || model?.slika_projekta_url;
    const scanSnapshotUrl = resolveStorageUrl(scanSnapshotPath);
    const scanSnapshotPreviewUrl = scanSnapshotUrl ? (scanSnapshotUrl.includes('?') ? `${scanSnapshotUrl}&t=${snapshotCacheKey}` : `${scanSnapshotUrl}?t=${snapshotCacheKey}`) : null;

    const uploadScanSnapshot = useCallback(
        async (pugiId, scanMeta, mode, barkod) => {
            if (!pugiId || !scanMeta?.file) {
                return false;
            }

            try {
                const formData = new FormData();
                formData.append('image', scanMeta.file);

                const response = await uploadImage(pugiId, formData);
                const updatedData = response?.data;

                if (updatedData?.slika_projekta_url) {
                    setValue('slika_projekta_url', updatedData.slika_projekta_url, { shouldDirty: false });
                    setSnapshotCacheKey(Date.now());
                }

                if (updatedData) {
                    setModel((prev) => ({ ...prev, ...updatedData }));
                }

                console.info('[PUGI][QR] Snapshot sacuvan', {
                    pugiId,
                    mode,
                    barkod,
                    path: updatedData?.slika_projekta_url || null
                });

                toast.current?.show({
                    severity: 'success',
                    summary: 'Snapshot',
                    detail: 'Snapshot je automatski sacuvan uz PUGI nalog.',
                    life: 3000
                });

                return true;
            } catch (error) {
                console.error('[PUGI][QR] Neuspesno cuvanje snapshot-a', error);
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Snapshot',
                    detail: 'Barkod je procitan, ali snapshot nije sacuvan.',
                    life: 3500
                });
                return false;
            }
        },
        [setValue, uploadImage]
    );

    const showUgiPreview = () => {
        const currentMm = mmSelected || model?.mm;
        const fileUrl = resolveUgiSkicaUrl(currentMm);

        if (!fileUrl) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'UGI skica nije dostupna.', life: 3000 });
            return;
        }

        setPreviewDialog({ visible: true, file: fileUrl });
        setPreviewError(null);
        setPreviewNumPages(0);
        setPdfScale(1);
    };

    // Save current step to localStorage when it changes (only after initial load is done)
    useEffect(() => {
        if (id && activeIndex !== undefined && initialLoadDone.current) {
            localStorage.setItem(`pugi_step_${id}`, activeIndex.toString());
        }
    }, [id, activeIndex]);

    useEffect(() => {
        if (!id) {
            reset(defaultValues);
            setModel({});
            setActiveIndex(0);
            return;
        }

        getPugi(id)
            .then((res) => {
                setModel(res.data);
                // Populate email from mm.p.email_korisnika if available
                const emailFromDb = res.data?.mm?.p?.email_korisnika || '';
                const poslatEmail = res.data?.mm?.p?.poslati_izvestaj_email || false;
                const poslatPostom = res.data?.mm?.p?.poslati_izvestaj_postom || false;
                reset({ ...res.data, emailAddress: emailFromDb, poslati_izvestaj_email: poslatEmail, poslati_izvestaj_postom: poslatPostom });

                // Restore saved step from localStorage, but only if record is not finished (status !== 3)
                const savedStep = localStorage.getItem(`pugi_step_${id}`);
                if (savedStep !== null && res.data.status_id !== 3) {
                    const stepIndex = parseInt(savedStep, 10);
                    // Validate step index is within bounds
                    if (!isNaN(stepIndex) && stepIndex >= 0 && stepIndex <= 3) {
                        setActiveIndex(stepIndex);
                    } else {
                        setActiveIndex(0);
                    }
                } else {
                    setActiveIndex(0);
                    // Clear saved step if record is finished
                    if (res.data.status_id === 3) {
                        localStorage.removeItem(`pugi_step_${id}`);
                    }
                }
                // Mark initial load as done so step changes can be saved to localStorage
                initialLoadDone.current = true;
            })
            .catch((error) => {
                console.error('Greška pri učitavanju PUGI zapisa:', error);
                toast.current?.show({ severity: 'error', summary: 'Greška', detail: 'Nije moguće učitati zapis.', life: 3000 });
            });
    }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!pendingScanSnapshot) {
            return;
        }

        const pugiId = Number(model?.id || id || 0);
        if (!pugiId) {
            return;
        }

        let active = true;

        uploadScanSnapshot(pugiId, pendingScanSnapshot.scanMeta, pendingScanSnapshot.mode, pendingScanSnapshot.barkod).finally(() => {
            if (active) {
                setPendingScanSnapshot(null);
            }
        });

        return () => {
            active = false;
        };
    }, [pendingScanSnapshot, model?.id, id, uploadScanSnapshot]);

    const statusTemplate = (doc) => {
        const _status = getSeverity(doc.status_id);
        return <Tag value={_status.name} severity={_status.color}></Tag>;
    };

    const getSeverity = (status) => {
        switch (status) {
            case 1:
                return { name: 'KREIRAN', color: 'danger' };

            case 2:
                return { name: 'U RADU', color: 'warning' };

            case 3:
                return { name: 'ZAVRŠEN', color: 'success' };

            default:
                return { name: 'U PRIPREMI', color: 'default' };
        }
    };

    const statusChange = watch('status_id');

    const vpChecked = watch('vp'); // posmatramo checkbox

    // kad se isključi, resetujemo polje rvp_id
    useEffect(() => {
        if (!vpChecked) {
            setValue('rvp_id', '');
        }
    }, [vpChecked, setValue]);

    const hidePreviewDialog = () => {
        setPreviewDialog({ visible: false, file: null });
        setPreviewError(null);
        setPreviewNumPages(0);
        setPdfScale(1);
        setPreviewWidth(600);
    };

    useEffect(() => {
        if (!previewDialog.visible) {
            return;
        }

        const updateWidth = () => {
            if (previewContainerRef.current) {
                setPreviewWidth(previewContainerRef.current.clientWidth);
            }
        };

        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, [previewDialog.visible]);

    const zoomIn = () => setPdfScale((value) => Math.min(value + 0.2, 3));
    const zoomOut = () => setPdfScale((value) => Math.max(value - 0.2, 0.6));
    const resetZoom = () => setPdfScale(1);

    const onSelectMM = (selectedModel) => {
        setValue('mm', selectedModel);
        setValue('mm_id', selectedModel.id);
        // Populate email address from selected MM if available
        const emailFromMm = selectedModel?.p?.email_korisnika || '';
        setValue('emailAddress', emailFromMm);
        setMmSelectDialog(false);
    };

    // removed unused handlers handleAddMMBarcode/handleAddMMSelect (UI commented)

    const onSignature = async (formData) => {
        try {
            // Sačuvaj lokalna polja pre reset-a (nisu u bazi)
            const emailAddress = getValues('emailAddress');
            const poslatiIzvestajEmail = getValues('poslati_izvestaj_email');

            uploadSignatureImage(model.id, formData).then((response) => {
                setSignatureDialog(false);
                setModel(response.data);
                // Resetuj sa podacima sa servera, ali sačuvaj lokalna polja
                reset({ ...response.data, emailAddress, poslati_izvestaj_email: poslatiIzvestajEmail });
                toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('image_uploaded'), life: 3000 });
            });
        } catch (error) {
            console.error('Upload failed:', error.response?.data || error.message);
        }
    };

    // removed unused handleUpload (image upload moved out of steps)

    const onScanneHandler = (barkod, scanMeta) => {
        const mode = scannerModeRef.current;
        const currentPugiId = Number(model?.id || getValues('id') || id || 0) || null;

        console.info('[PUGI][QR] Skeniran barkod', {
            mode,
            barkod,
            snapshotCaptured: !!scanMeta?.file,
            snapshotSize: scanMeta ? `${scanMeta.width}x${scanMeta.height}` : null,
            capturedAt: scanMeta?.capturedAt || null
        });

        if (scanMeta?.file) {
            if (currentPugiId) {
                void uploadScanSnapshot(currentPugiId, scanMeta, mode, barkod);
            } else {
                setPendingScanSnapshot({ scanMeta, mode, barkod });
                toast.current?.show({
                    severity: 'info',
                    summary: 'Snapshot',
                    detail: 'Snapshot je spreman i bice automatski sacuvan kada nalog dobije ID.',
                    life: 3500
                });
                console.info('[PUGI][QR] Snapshot je privremeno sacuvan i ceka ID naloga.');
            }
        }

        if (mode === 'broj_merila') {
            // Skeniranje broja merila - upiši direktno u polje
            setValue('broj_merila_pugi', barkod);
            setShowQrScaner(false);
            toast.current?.show({
                severity: 'success',
                summary: 'Skenirano',
                detail: scanMeta?.file ? `Broj merila: ${barkod} (snapshot uhvacen)` : `Broj merila: ${barkod}`,
                life: 2500
            });
        } else {
            // Default: skeniranje MM barkoda
            let filters = {};
            filters['barkod[value]'] = barkod;
            filters['barkod[matchMode]'] = 'contains';

            const params = {
                page: 1,
                perPage: 1,
                sortBy: 'id',
                sortOrder: 'asc',
                paginator: false,
                ...filters
            };
            getMmsLazy(params)
                .then((res) => {
                    const selectedMm = res?.data?.[0];
                    if (!selectedMm) {
                        toast.current?.show({ severity: 'warn', summary: 'Skenirano', detail: `MM nije pronadjen za barkod: ${barkod}`, life: 3500 });
                        console.warn('[PUGI][QR] MM nije pronadjen za barkod', barkod);
                        setShowQrScaner(false);
                        return;
                    }

                    setValue('mm', selectedMm);
                    setValue('mm_id', selectedMm.id);
                    setShowQrScaner(false);
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Skenirano',
                        detail: scanMeta?.file ? `MM barkod uspesno ocitan (snapshot uhvacen)` : `MM barkod uspesno ocitan`,
                        life: 2500
                    });
                })
                .catch((error) => {
                    console.error('[PUGI][QR] Greska pri pretrazi MM po barkodu', error);
                    toast.current?.show({ severity: 'error', summary: 'Greska', detail: 'Neuspesna pretraga MM po barkodu.', life: 3500 });
                    setShowQrScaner(false);
                });
        }
    };

    const downloadFile = (blob, filename) => {
        try {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'download.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error(e);
        }
    };

    const onSubmit = (rawData) => {
        const data = formatDateFields(rawData);
        switch (actionType) {
            case 'save_exit': {
                const afterSuccess = (resolve) => {
                    setModel(resolve.data);
                    reset(resolve.data);
                    toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: data.id ? i18n.t('success_edit') : i18n.t('success_create'), life: 3000 });
                    navigate('/');
                };
                if (data.id) {
                    updatePugi(data.id, data).then(
                        (resolve) => afterSuccess(resolve),
                        (reject) => {
                            reject.errors.forEach((error) => {
                                toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                            });
                        }
                    );
                } else {
                    createPugi(data).then(
                        (resolve) => afterSuccess(resolve),
                        (reject) => {
                            reject.errors.forEach((error) => {
                                toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                            });
                        }
                    );
                }
                break;
            }
            case 'save': {
                if (data.id) {
                    updatePugi(data.id, data).then(
                        (resolve) => {
                            setModel(resolve.data);
                            reset(resolve.data);
                            toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('success_edit'), life: 3000 });
                        },
                        (reject) => {
                            // foreach errors and show toast
                            reject.errors.forEach((error) => {
                                toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                            });
                        }
                    );
                } else {
                    createPugi(data).then(
                        (resolve) => {
                            setModel(resolve.data);
                            reset(resolve.data);
                            toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('success_create'), life: 3000 });
                            navigate(`/pugi/${resolve.data.id}/edit`);
                        },
                        (reject) => {
                            // foreach errors and show toast
                            reject.errors.forEach((error) => {
                                toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                            });
                        }
                    );
                }
                break;
            }
            case 'start': {
                if (data.potrosac_nije_kuci) {
                    toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Ne možete započeti proveru dok potrošač nije kod kuće.', life: 3000 });
                    setActionType('');
                    return;
                }
                if (data.stranka_ne_omogucava_pregled) {
                    toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Ne možete započeti proveru - stranka ne omogućava pregled.', life: 3000 });
                    setActionType('');
                    return;
                }
                startPugi(data).then(
                    (resolve) => {
                        setModel(resolve.data);
                        reset(resolve.data);
                        toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: resolve.message, life: 3000 });

                        // if data.id exists stay on the same page
                        if (data.id) {
                            // odmah prebacije na sledeći korak
                            setActiveIndex(1);
                        } else {
                            navigate(`/pugi/${resolve.data.id}/edit`);
                        }
                    },
                    (reject) => {
                        // foreach errors and show toast
                        reject.errors.forEach((error) => {
                            toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                        });
                    }
                );

                break;
            }

            case 'end': {
                if (!isInstallationFilled()) {
                    toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Unesite stanje instalacije pre završetka.', life: 3000 });
                    setActionType('');
                    break;
                }
                if (!hasSignature()) {
                    toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Potrebno je sačuvati potpis korisnika pre završetka.', life: 3000 });
                    setActionType('');
                    break;
                }

                // Prepare data with email notification params and izvestaj preferences
                const endData = {
                    ...data,
                    send_email: (data.poslati_izvestaj_email && !!data.emailAddress) || false,
                    email_adresa: data.poslati_izvestaj_email ? data.emailAddress : null,
                    poslati_izvestaj_email: data.poslati_izvestaj_email || false,
                    poslati_izvestaj_postom: data.poslati_izvestaj_postom || false
                };

                setFinishing(true);

                const locationService = LocationService();
                let geoData = {};

                locationService
                    .getCurrentLocation()
                    .then((loc) => {
                        geoData = {
                            latitude: loc.latitude,
                            longitude: loc.longitude,
                            accuracy: loc.accuracy
                        };
                    })
                    .catch((geoErr) => {
                        console.warn('GPS nije dostupan:', geoErr?.message || geoErr);
                    })
                    .finally(() => {
                        const endPayload = { ...endData, ...geoData };

                        endPugi(endPayload).then(
                            (resolve) => {
                                setFinishing(false);
                                setModel(resolve.data);
                                reset(resolve.data);
                                // Clear saved step from localStorage when record is finished
                                localStorage.removeItem(`pugi_step_${id}`);
                                toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('end_check'), life: 3000 });

                                if (endPayload.send_email && endPayload.email_adresa) {
                                    toast.current.show({ severity: 'info', summary: 'Email', detail: `Izveštaj je poslat na ${endPayload.email_adresa}`, life: 4000 });
                                }

                                // after end wait for 2 seconds and go to list
                                setTimeout(() => {
                                    navigate('/');
                                }, 2000);
                            },
                            (reject) => {
                                setFinishing(false);
                                // foreach errors and show toast
                                reject.errors.forEach((error) => {
                                    toast.current.show({ severity: 'error', summary: i18n.t('error'), detail: error, life: 3000 });
                                });
                            }
                        );
                    });

                break;
            }
            case 'back': {
                navigate('/');
                break;
            }
            case 'pdf': {
                pdfPugi(data.id)
                    .then(({ blob, filename }) => {
                        downloadFile(blob, filename);
                    })
                    .catch(() => {
                        toast.current?.show({ severity: 'error', summary: i18n.t('error'), detail: 'PDF', life: 3000 });
                    });

                break;
            }

            default: {
                break;
            }
        }

        setActionType(''); // reset action type
    };

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>;
    };

    const hideDeleteModelDialog = () => {
        setDeleteModelDialog(false);
    };

    // removed unused confirmDeleteModel (delete disabled in multi-step UI)

    const deleteModel = () => {
        deletePugi(model.id).then((res) => {
            hideDeleteModelDialog();
            toast.current.show({ severity: 'success', summary: i18n.t('success'), detail: i18n.t('success_deleted'), life: 3000 });
            navigate('/pugi');
        });
    };

    const deleteModelDialogFooter = (
        <React.Fragment>
            <Button label={i18n.t('no')} icon="pi pi-times" outlined onClick={hideDeleteModelDialog} />
            <Button label={i18n.t('yes')} icon="pi pi-check" severity="danger" onClick={deleteModel} />
        </React.Fragment>
    );

    // Watch values for conditional comment field visibility
    const potrebnaIntervencija = watch('potrebna_intervencija');
    const saniranProblem = watch('saniran_problem');

    // Check if comment fields should be visible
    const shouldShowKomentarIntervencije = potrebnaIntervencija !== defaultValues.potrebna_intervencija;
    const shouldShowKomentarSanacije = saniranProblem !== defaultValues.saniran_problem;

    const { canStartPugi, canEndPugi } = usePermissions();

    // Step definitions
    const stepDefinitions = ['Merno mesto', 'Stavke za pregled', 'Tehnički podaci', 'Instalacija / Potpis'];

    const isInstallationFilled = () => {
        const val = watch('si_id');
        // Check for valid value: not undefined, not null, not empty string, and not 0 if it's falsy
        return val !== undefined && val !== null && val !== '' && val !== 0;
    };

    const hasSignature = () => {
        if (watch('stranka_nece_da_potpise')) return true;
        const val = watch('potpis_url');
        return val !== undefined && val !== null && String(val).trim() !== '';
    };

    const validateStep = () => {
        if (activeIndex === 0 && !getValues('mm_id')) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Odaberite merno mesto', life: 2500 });
            return false;
        }
        if (activeIndex === 0 && getValues('potrosac_nije_kuci')) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Potrošač nije kod kuće - ne možete nastaviti.', life: 3000 });
            return false;
        }
        if (activeIndex === 0 && getValues('stranka_ne_omogucava_pregled')) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Stranka ne omogućava pregled - ne možete nastaviti.', life: 3000 });
            return false;
        }
        return true;
    };

    const goNext = async () => {
        if (saving) return;
        if (!validateStep()) return;
        if (activeIndex >= 1 && statusChange === 1) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Započnite proveru pre nastavka na sledeće korake.', life: 3000 });
            return;
        }
        if (isDirty) {
            try {
                setSaving(true);
                const formData = formatDateFields(getValues());
                if (formData.id) {
                    await updatePugi(formData.id, formData).then((resolve) => {
                        setModel(resolve.data);
                        reset(resolve.data);
                    });
                } else {
                    await createPugi(formData).then((resolve) => {
                        setModel(resolve.data);
                        reset(resolve.data);
                        navigate(`/pugi/${resolve.data.id}/edit`);
                    });
                }
            } catch (e) {
                toast.current?.show({ severity: 'error', summary: 'Greška', detail: 'Auto čuvanje nije uspelo.', life: 3000 });
                setSaving(false);
                return;
            }
            setSaving(false);
        }
        setActiveIndex((i) => Math.min(i + 1, stepDefinitions.length - 1));
    };

    const goPrev = () => {
        if (activeIndex === 0) {
            navigate(-1);
            return;
        }
        setActiveIndex((i) => Math.max(i - 1, 0));
    };

    // Save current form state before opening signature dialog
    const openSignatureDialogSafely = async () => {
        if (saving) return;
        const formData = formatDateFields(getValues());
        // Sačuvaj lokalna polja pre reset-a (nisu u bazi)
        const emailAddress = getValues('emailAddress');
        const poslatiIzvestajEmail = getValues('poslati_izvestaj_email');

        if (!formData?.mm_id) {
            toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Odaberite merno mesto pre potpisa.', life: 2500 });
            return;
        }
        try {
            setSaving(true);
            if (formData.id) {
                await updatePugi(formData.id, formData).then((resolve) => {
                    setModel(resolve.data);
                    reset({ ...resolve.data, emailAddress, poslati_izvestaj_email: poslatiIzvestajEmail });
                });
            } else {
                await createPugi(formData).then((resolve) => {
                    setModel(resolve.data);
                    reset({ ...resolve.data, emailAddress, poslati_izvestaj_email: poslatiIzvestajEmail });
                    // Ensure URL contains id for subsequent actions (like signature upload)
                    navigate(`/pugi/${resolve.data.id}/edit`);
                });
            }
            // Open signature dialog after successful save
            setSignatureDialog(true);
        } catch (e) {
            // Show backend validation errors if present
            const errs = e?.errors || [e?.message || 'Greška pri čuvanju podataka.'];
            errs.forEach((err) => toast.current?.show({ severity: 'error', summary: 'Greška', detail: err, life: 3000 }));
        } finally {
            setSaving(false);
        }
    };

    const togglePotrosacNijeKodKuce = async () => {
        const trenutnoNijeKodKuce = !!getValues('potrosac_nije_kuci');

        // Ako je trenutno oznaceno da nije kod kuce, klik vraca na "kod kuce".
        if (trenutnoNijeKodKuce) {
            setValue('potrosac_nije_kuci', false, { shouldDirty: true });
            return;
        }

        // Evidentiranje izlaska u backendu ima smisla pre starta i za sacuvan nalog.
        if (id && statusChange === 1) {
            try {
                const locationService = LocationService();
                let geoData = {};
                try {
                    const loc = await locationService.getCurrentLocation();
                    geoData = { latitude: loc.latitude, longitude: loc.longitude, accuracy: loc.accuracy };
                } catch (geoErr) {
                    console.warn('GPS nije dostupan:', geoErr.message);
                }

                await nijeKodKuce(id, geoData);
                setValue('potrosac_nije_kuci', true, { shouldDirty: true });
                toast.current?.show({ severity: 'success', summary: 'Evidentirano', detail: 'Potrošač nije kod kuće - izlazak zabeležen.', life: 3500 });
                return;
            } catch (e) {
                const msg = e?.response?.data?.message || 'Nije moguće evidentirati izlazak.';
                toast.current?.show({ severity: 'error', summary: 'Greška', detail: msg, life: 3000 });
                return;
            }
        }

        setValue('potrosac_nije_kuci', true, { shouldDirty: true });
    };

    const toggleStrankaNeOmogucavaPregled = async () => {
        const trenutnoNeOmogucava = !!getValues('stranka_ne_omogucava_pregled');

        // Ako je trenutno blokirano, klik vraca na "omogucava pregled".
        if (trenutnoNeOmogucava) {
            setValue('stranka_ne_omogucava_pregled', false, { shouldDirty: true });
            return;
        }

        // Evidentiranje izlaska u backendu ima smisla pre starta i za sacuvan nalog.
        if (id && statusChange === 1) {
            try {
                await neOmogucavaPregled(id);
                setValue('stranka_ne_omogucava_pregled', true, { shouldDirty: true });
                toast.current?.show({ severity: 'success', summary: 'Evidentirano', detail: 'Stranka ne omogućava pregled - izlazak zabeležen.', life: 3500 });
                return;
            } catch (e) {
                const msg = e?.response?.data?.message || 'Nije moguće evidentirati izlazak.';
                toast.current?.show({ severity: 'error', summary: 'Greška', detail: msg, life: 3000 });
                return;
            }
        }

        setValue('stranka_ne_omogucava_pregled', true, { shouldDirty: true });
    };

    useEffect(() => {
        if (statusChange === 1 && activeIndex > 1) {
            setActiveIndex(1);
            if (!gatingWarnShown.current) {
                toast.current?.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Nije moguće ići dalje dok ne započnete proveru.', life: 3000 });
                gatingWarnShown.current = true;
            }
        }
        if (statusChange !== 1) gatingWarnShown.current = false;
    }, [statusChange, activeIndex]);

    const renderStepContent = () => {
        switch (activeIndex) {
            case 0:
                return (
                    <div key="step-0" className="grid formgrid p-fluid px-1">
                        {watch('mm') ? <MMInfo mm={watch('mm')} /> : ''}

                        {scanSnapshotPreviewUrl && (
                            <div className="field col-12">
                                <div className="surface-100 border-round p-3">
                                    <div className="flex align-items-center justify-content-between gap-2 flex-wrap">
                                        <span className="font-medium">Snapshot sa skeniranja barkoda</span>
                                        <Button type="button" text icon="pi pi-external-link" label="Otvori sliku" onClick={() => window.open(scanSnapshotPreviewUrl, '_blank', 'noopener')} />
                                    </div>
                                    <img src={scanSnapshotPreviewUrl} alt="Snapshot barkoda" className="w-full md:w-6 border-round mt-2" />
                                    <small className="text-500 block mt-2">Ova fotografija je automatski sacuvana pri skeniranju i dostupna je i nakon realizacije naloga.</small>
                                </div>
                            </div>
                        )}

                        {(resolveUgiSkicaUrl(mmSelected || model?.mm) && (
                            <div className="field md:col-2 col-12 flex align-items-end">
                                <Button type="button" outlined icon="pi pi-file-pdf" label="Pregled UGI skice" onClick={showUgiPreview} className="w-full" />
                            </div>
                        )) ||
                            null}
                        <div className="field md:col-3 col-12">
                            <label htmlFor="potrosac-status-btn" className={classNames('w-12', { 'p-error': errors.potrosac_nije_kuci })}>
                                {i18n.t('pugi.potrosac_nije_kuci')}
                            </label>
                            <Button
                                id="potrosac-status-btn"
                                type="button"
                                className="w-full"
                                severity={watch('potrosac_nije_kuci') ? 'success' : 'warning'}
                                outlined={!watch('potrosac_nije_kuci')}
                                icon={watch('potrosac_nije_kuci') ? 'pi pi-check' : 'pi pi-home'}
                                label={watch('potrosac_nije_kuci') ? 'Potrošač je kod kuće' : 'Potrošač nije kod kuće'}
                                onClick={togglePotrosacNijeKodKuce}
                                disabled={!mmSelected || statusChange > 1}
                            />
                            {getFormErrorMessage('potrosac_nije_kuci')}
                            {watch('potrosac_nije_kuci') && statusChange === 1 && (
                                <small className="p-warning block" style={{ color: 'var(--yellow-600)' }}>
                                    Ne možete započeti proveru dok je ova opcija uključena.
                                </small>
                            )}
                        </div>

                        <div className="field md:col-3 col-12">
                            <label htmlFor="stranka-status-btn" className="w-12">
                                Stranka ne omogućava pregled
                            </label>
                            <Button
                                id="stranka-status-btn"
                                type="button"
                                className="w-full"
                                severity={watch('stranka_ne_omogucava_pregled') ? 'success' : 'danger'}
                                outlined={!watch('stranka_ne_omogucava_pregled')}
                                icon={watch('stranka_ne_omogucava_pregled') ? 'pi pi-check' : 'pi pi-ban'}
                                label={watch('stranka_ne_omogucava_pregled') ? 'Stranka omogućava pregled UGI-a' : 'Stranka ne omogućava pregled UGI-a'}
                                onClick={toggleStrankaNeOmogucavaPregled}
                                disabled={!mmSelected || statusChange > 1}
                            />
                            {watch('stranka_ne_omogucava_pregled') && statusChange === 1 && (
                                <small className="p-warning block" style={{ color: 'var(--yellow-600)' }}>
                                    Ne možete započeti proveru dok je ova opcija uključena.
                                </small>
                            )}
                        </div>

                        <div className="field md:col-2 col-12">
                            <label htmlFor="vp" className={classNames('w-12', { 'p-error': errors.vp })}>
                                {i18n.t('pugi.vp')}
                            </label>
                            <Controller name="vp" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('vp')}
                        </div>
                        {vpChecked && (
                            <div className="field md:col-2 col-12">
                                <label htmlFor="rvp_id" className={classNames({ 'p-error': errors.rvp_id })}>
                                    {i18n.t('pugi.rvp_id')}
                                </label>
                                <Controller
                                    name="rvp_id"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                        <Dropdown id={field.name} {...field} options={rvps} optionLabel="opis" optionValue="id" optionDisabled={(option) => option.aktivan === 0} className={classNames({ invalid: fieldState.invalid })} />
                                    )}
                                />
                                {getFormErrorMessage('rvp_id')}
                            </div>
                        )}
                    </div>
                );
            case 1:
                return (
                    <div key="step-1" className="grid formgrid p-fluid px-1">
                        <div className="field md:col-2 col-6">
                            <label htmlFor="ostecen" className={classNames('w-12', { 'p-error': errors.ostecen })}>
                                {i18n.t('pugi.ostecen')}
                            </label>
                            <Controller name="ostecen" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('ostecen')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="funkcionalan" className={classNames('w-12', { 'p-error': errors.funkcionalan })}>
                                {i18n.t('pugi.funkcionalan')}
                            </label>
                            <Controller name="funkcionalan" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('funkcionalan')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="nepropustan" className={classNames('w-12', { 'p-error': errors.nepropustan })}>
                                {i18n.t('pugi.nepropustan')}
                            </label>
                            <Controller name="nepropustan" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('nepropustan')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="ni_id" className={classNames({ 'p-error': errors.ni_id })}>
                                {i18n.t('pugi.ni_id')}
                            </label>
                            <Controller
                                name="ni_id"
                                control={control}
                                render={({ field, fieldState }) => <Dropdown id={field.name} {...field} options={nis} optionLabel="opis" optionValue="id" className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('ni_id')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="potrebna_intervencija" className={classNames('w-12', { 'p-error': errors.potrebna_intervencija })}>
                                {i18n.t('pugi.potrebna_intervencija')}
                            </label>
                            <Controller
                                name="potrebna_intervencija"
                                control={control}
                                render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('potrebna_intervencija')}
                        </div>
                        {shouldShowKomentarIntervencije && (
                            <div className="field md:col-2 col-6">
                                <label htmlFor="komentar_intervencije" className={classNames({ 'p-error': errors.komentar_intervencije })}>
                                    {i18n.t('pugi.komentar_intervencije')}
                                </label>
                                <Controller
                                    name="komentar_intervencije"
                                    control={control}
                                    render={({ field, fieldState }) => <InputText id={field.name} {...field} style={{ backgroundColor: '#fff3e0' }} className={classNames({ invalid: fieldState.invalid })} />}
                                />
                                {getFormErrorMessage('komentar_intervencije')}
                            </div>
                        )}
                        <div className="field md:col-2 col-6">
                            <label htmlFor="broj_kontrole_kotla" className={classNames({ 'p-error': errors.broj_kontrole_kotla })}>
                                {i18n.t('pugi.broj_kontrole_kotla')}
                            </label>
                            <Controller name="broj_kontrole_kotla" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('broj_kontrole_kotla')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="datum_kontrole_kotla" className={classNames({ 'p-error': errors.datum_kontrole_kotla })}>
                                {i18n.t('pugi.datum_kontrole_kotla')}
                            </label>
                            <Controller
                                name="datum_kontrole_kotla"
                                control={control}
                                render={({ field, fieldState }) => (
                                    <Calendar
                                        {...field}
                                        inputId={field.name}
                                        value={new Date(field.value)}
                                        dateFormat="yy-mm-dd"
                                        onChange={(e) => {
                                            const formatDate = moment(e.value).format('YYYY-MM-DD');
                                            field.onChange(formatDate);
                                        }}
                                        className={classNames({ 'p-invalid': fieldState.error })}
                                    />
                                )}
                            />
                            {getFormErrorMessage('datum_kontrole_kotla')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="saniran_problem" className={classNames('w-12', { 'p-error': errors.saniran_problem })}>
                                {i18n.t('pugi.saniran_problem')}
                            </label>
                            <Controller name="saniran_problem" control={control} render={({ field, fieldState }) => <InputSwitch inputId={field.name} checked={field.value} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('saniran_problem')}
                        </div>
                        {shouldShowKomentarSanacije && (
                            <div className="field md:col-2 col-6">
                                <label htmlFor="datum_sanacije" className={classNames({ 'p-error': errors.datum_sanacije })}>
                                    {i18n.t('pugi.datum_sanacije')}
                                </label>
                                <Controller
                                    name="datum_sanacije"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                        <Calendar
                                            {...field}
                                            inputId={field.name}
                                            value={new Date(field.value)}
                                            dateFormat="yy-mm-dd"
                                            onChange={(e) => {
                                                const formatDate = moment(e.value).format('YYYY-MM-DD');
                                                field.onChange(formatDate);
                                            }}
                                            className={classNames({ 'p-invalid': fieldState.error })}
                                        />
                                    )}
                                />
                                {getFormErrorMessage('datum_sanacije')}
                            </div>
                        )}
                        {shouldShowKomentarSanacije && (
                            <div className="field md:col-2 col-6">
                                <label htmlFor="komentar_sanacije" className={classNames({ 'p-error': errors.komentar_sanacije })}>
                                    {i18n.t('pugi.komentar_sanacije')}
                                </label>
                                <Controller
                                    name="komentar_sanacije"
                                    control={control}
                                    render={({ field, fieldState }) => <InputText id={field.name} {...field} style={{ backgroundColor: '#fff3e0' }} className={classNames({ invalid: fieldState.invalid })} />}
                                />
                                {getFormErrorMessage('komentar_sanacije')}
                            </div>
                        )}
                    </div>
                );
            case 2:
                // Opcije za SelectButton i MultiSelect
                const vodjenjeOptions = [
                    { label: 'Spolja', value: 'spolja' },
                    { label: 'Podzemno', value: 'podzemno' },
                    { label: 'Kombinovano', value: 'kombinovano' }
                ];
                const materijalOptions = [
                    { label: 'Cu (Bakar)', value: 'Cu' },
                    { label: 'Fe (Čelik)', value: 'Fe' },
                    { label: 'PE (Polietilen)', value: 'PE' }
                ];
                const ispravnostOptions = [
                    { label: 'Ispravni', value: true },
                    { label: 'Neispravni', value: false }
                ];
                const imaNemaOptions = [
                    { label: 'Ima', value: true },
                    { label: 'Nema', value: false }
                ];
                const daNeOptions = [
                    { label: 'DA', value: true },
                    { label: 'NE', value: false }
                ];

                return (
                    <div key="step-2" className="grid formgrid p-fluid px-1">
                        {/* Izvedeno odgovara projektu */}
                        <div className="field md:col-3 col-7">
                            <label htmlFor="izvedeno_odgovara_projektu">Izvedeno odgovara projektu</label>
                            <Controller
                                name="izvedeno_odgovara_projektu"
                                control={control}
                                render={({ field }) => <SelectButton id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={daNeOptions} className="w-full" />}
                            />
                        </div>

                        {/* Pritisak gasa ispred trošila */}
                        <div className="field md:col-3 col-5">
                            <label htmlFor="pritisak_gasa">Pritisak gasa (mbar)</label>
                            <Controller name="pritisak_gasa" control={control} render={({ field }) => <InputText id={field.name} {...field} placeholder="22" />} />
                        </div>

                        {/* Vođenje instalacije */}
                        <div className="field md:col-3 col-12">
                            <label htmlFor="vodjenje_instalacije">Vođenje instalacije</label>
                            <Controller
                                name="vodjenje_instalacije"
                                control={control}
                                render={({ field }) => <SelectButton id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={vodjenjeOptions} className="w-full" />}
                            />
                        </div>

                        {/* Materijal instalacije */}
                        <div className="field md:col-4 col-12">
                            <label htmlFor="materijal_instalacije">Materijal instalacije</label>
                            <Controller
                                name="materijal_instalacije"
                                control={control}
                                render={({ field }) => <MultiSelect id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={materijalOptions} placeholder="Izaberite materijal" display="chip" className="w-full" />}
                            />
                        </div>

                        {/* Nosači */}
                        <div className="field md:col-4 col-6">
                            <label htmlFor="nosaci_ispravni">Nosači</label>
                            <Controller name="nosaci_ispravni" control={control} render={({ field }) => <SelectButton id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={ispravnostOptions} className="w-full" />} />
                        </div>

                        {/* Zaporni organi */}
                        <div className="field md:col-4 col-6">
                            <label htmlFor="zaporni_organi_ispravni">Zaporni organi</label>
                            <Controller
                                name="zaporni_organi_ispravni"
                                control={control}
                                render={({ field }) => <SelectButton id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={ispravnostOptions} className="w-full" />}
                            />
                        </div>

                        {/* Fleksibilne veze */}
                        <div className="field md:col-4 col-6">
                            <label htmlFor="fleksibilne_veze_ispravne">Fleksibilne veze</label>
                            <Controller
                                name="fleksibilne_veze_ispravne"
                                control={control}
                                render={({ field }) => <SelectButton id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={ispravnostOptions} className="w-full" />}
                            />
                        </div>

                        {/* Premošćenje potencijala */}
                        <div className="field md:col-4 col-6">
                            <label htmlFor="premoscenje_potencijala">Premošćenje potencijala</label>
                            <Controller
                                name="premoscenje_potencijala"
                                control={control}
                                render={({ field }) => <SelectButton id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={imaNemaOptions} className="w-full" />}
                            />
                        </div>

                        {/* Dimnjak */}
                        <div className="field md:col-4 col-6">
                            <label htmlFor="dimnjak">Dimnjak</label>
                            <Controller name="dimnjak" control={control} render={({ field }) => <SelectButton id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={imaNemaOptions} className="w-full" />} />
                        </div>

                        {/* Datum čišćenja dimnjaka - prikazuje se samo ako dimnjak = true */}
                        {watch('dimnjak') && (
                            <div className="field md:col-4 col-6">
                                <label htmlFor="dimnjak_datum_ciscenja">Datum čišćenja dimnjaka</label>
                                <Controller
                                    name="dimnjak_datum_ciscenja"
                                    control={control}
                                    render={({ field }) => (
                                        <Calendar
                                            {...field}
                                            inputId={field.name}
                                            value={field.value ? new Date(field.value) : null}
                                            dateFormat="yy-mm-dd"
                                            onChange={(e) => {
                                                const formatDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                                                field.onChange(formatDate);
                                            }}
                                            showIcon
                                        />
                                    )}
                                />
                            </div>
                        )}

                        <div className="col-12 mt-3 mb-3">
                            <h5 className="text-primary m-0">Dodatni podaci korisnika</h5>
                        </div>

                        {/* Telefon korisnika */}
                        <div className="field md:col-4 col-6">
                            <label htmlFor="telefon_korisnika_pugi">Telefon korisnika</label>
                            <Controller name="telefon_korisnika_pugi" control={control} render={({ field }) => <InputText id={field.name} {...field} placeholder={watch('mm')?.p?.telefon_korisnika || 'Unesite telefon'} />} />
                            {watch('mm')?.p?.telefon_korisnika && <small className="text-500">Trenutno u bazi: {watch('mm')?.p?.telefon_korisnika}</small>}
                        </div>

                        {/* Broj merila */}
                        <div className="field md:col-4 col-6">
                            <label htmlFor="broj_merila_pugi">Broj merila</label>
                            <div className="p-inputgroup">
                                <Controller name="broj_merila_pugi" control={control} render={({ field }) => <InputText id={field.name} {...field} placeholder={watch('mm')?.m?.barkod_meraca || 'Unesite broj merila'} />} />
                                <Button
                                    type="button"
                                    onClick={() => {
                                        setScannerMode('broj_merila');
                                        setShowQrScaner(true);
                                    }}
                                    tooltip="Skeniraj broj merila"
                                >
                                    <FontAwesomeIcon icon={faBarcode} />
                                </Button>
                            </div>
                            {watch('mm')?.m?.barkod_meraca && <small className="text-500">Trenutno u bazi: {watch('mm')?.m?.barkod_meraca}</small>}
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div key="step-3" className="grid formgrid p-fluid px-1">
                        <div className="field md:col-2 col-12">
                            <label htmlFor="si_id" className={classNames({ 'p-error': errors.si_id })}>
                                {i18n.t('pugi.si_id')}
                            </label>
                            <Controller
                                name="si_id"
                                control={control}
                                render={({ field, fieldState }) => <Dropdown id={field.name} {...field} options={sis} optionLabel="opis" optionValue="id" className={classNames({ invalid: fieldState.invalid })} />}
                            />
                            {getFormErrorMessage('si_id')}
                            {statusChange === 2 && activeIndex === stepDefinitions.length - 1 && !isInstallationFilled() && <small className="p-error block">Morate odabrati stanje instalacije pre završetka.</small>}
                        </div>
                        <div className="field md:col-3 col-12">
                            <label htmlFor="tip_trosila_ids" className={classNames({ 'p-error': errors.tip_trosila_ids })}>
                                {i18n.t('pugi.tip_trosila_id')}
                            </label>
                            <Controller
                                name="tip_trosila_ids"
                                control={control}
                                render={({ field, fieldState }) => (
                                    <MultiSelect
                                        id={field.name}
                                        value={field.value}
                                        onChange={(e) => field.onChange(e.value)}
                                        options={tipTrosilas}
                                        optionLabel="opis"
                                        optionValue="id"
                                        optionDisabled={(option) => option.aktivan === 0}
                                        placeholder="Izaberite tip/ove trošila"
                                        display="chip"
                                        className={classNames('w-full', { invalid: fieldState.invalid })}
                                    />
                                )}
                            />
                            {getFormErrorMessage('tip_trosila_ids')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="marka_trosila_id" className={classNames({ 'p-error': errors.marka_trosila_id })}>
                                {i18n.t('pugi.marka_trosila_id')}
                            </label>
                            <Controller
                                name="marka_trosila_id"
                                control={control}
                                render={({ field, fieldState }) => (
                                    <Dropdown id={field.name} {...field} options={markaTrosilas} optionLabel="opis" optionValue="id" optionDisabled={(option) => option.aktivan === 0} className={classNames({ invalid: fieldState.invalid })} />
                                )}
                            />
                            {getFormErrorMessage('marka_trosila_id')}
                        </div>
                        <div className="field md:col-2 col-6">
                            <label htmlFor="snaga_trosila" className={classNames({ 'p-error': errors.snaga_trosila })}>
                                {i18n.t('pugi.snaga_trosila')}
                            </label>
                            <Controller name="snaga_trosila" control={control} render={({ field, fieldState }) => <InputText keyfilter="pnum" id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('snaga_trosila')}
                        </div>
                        <div className="field md:col-2 col-12">
                            <label htmlFor="potpis_ime_prezime" className={classNames({ 'p-error': errors.potpis_ime_prezime })}>
                                {i18n.t('pugi.potpis_ime_prezime')}
                            </label>
                            <Controller name="potpis_ime_prezime" control={control} render={({ field, fieldState }) => <InputText id={field.name} {...field} className={classNames({ invalid: fieldState.invalid })} />} />
                            {getFormErrorMessage('potpis_ime_prezime')}
                        </div>
                        <div className="field md:col-2 col-12">
                            <label htmlFor="stranka_nece_da_potpise" className="w-12 font-bold" style={{ color: 'var(--red-600)' }}>
                                Stranka neće da potpiše
                            </label>
                            <Controller name="stranka_nece_da_potpise" control={control} render={({ field }) => <InputSwitch inputId={field.name} checked={field.value} onChange={(e) => field.onChange(e.value)} />} />
                        </div>
                        <div className="field md:col-2 col-12">
                            <label htmlFor="potpis_url" className={classNames({ 'p-error': errors.potpis_url })}>
                                {i18n.t('pugi.potpis_url')}
                            </label>
                            {watch('stranka_nece_da_potpise') ? (
                                <Tag value="Stranka je odbila potpisivanje zapisnika" severity="warning" icon="pi pi-exclamation-triangle" className="w-full" />
                            ) : (
                                <>
                                    <div className="field col-12 ">
                                        {model?.potpis_url ? <img src={`${storage}${getValues('potpis_url')}?t=${Date.now()}`} alt="Potpis" className="w-full md:w-3" crossOrigin="anonymous" referrerPolicy="no-referrer" /> : <p>Nema potpisa</p>}
                                    </div>
                                    <Button label="Potpiši korisnika" icon={saving ? 'pi pi-spin pi-spinner' : 'pi pi-upload'} disabled={saving} onClick={openSignatureDialogSafely} />
                                    {statusChange === 2 && activeIndex === stepDefinitions.length - 1 && !hasSignature() && <small className="p-error block">Potpis korisnika je obavezan pre završetka.</small>}
                                </>
                            )}
                            {getFormErrorMessage('potpis_url')}
                        </div>
                        <div className="field col-12">
                            <div className="surface-100 border-round p-3">
                                <p className="font-medium mb-2 mt-0">Preferencije slanja izveštaja potrošaču</p>
                                <div className="flex gap-4 flex-wrap">
                                    <div className="flex flex-column gap-2">
                                        <div className="flex align-items-center gap-2">
                                            <Controller name="poslati_izvestaj_email" control={control} render={({ field }) => <InputSwitch inputId="poslati_izvestaj_email" checked={field.value} onChange={(e) => field.onChange(e.value)} />} />
                                            <label htmlFor="poslati_izvestaj_email">
                                                Potrošač želi izveštaj na <strong>email</strong>
                                            </label>
                                        </div>
                                        {watch('poslati_izvestaj_email') && (
                                            <div className="mt-1">
                                                <Controller
                                                    name="emailAddress"
                                                    control={control}
                                                    render={({ field, fieldState }) => <InputText id={field.name} {...field} placeholder="primer@email.com" className={classNames('w-full', { 'p-invalid': fieldState.invalid })} />}
                                                />
                                                {getFormErrorMessage('emailAddress')}
                                                <small className="block mt-1 text-500">PDF izveštaj će biti poslat na ovu adresu.</small>
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <Controller name="poslati_izvestaj_postom" control={control} render={({ field }) => <InputSwitch inputId="poslati_izvestaj_postom" checked={field.value} onChange={(e) => field.onChange(e.value)} />} />
                                        <label htmlFor="poslati_izvestaj_postom">
                                            Potrošač želi izveštaj <strong>poštom</strong>
                                        </label>
                                    </div>
                                </div>
                                <small className="text-500 block mt-2">Odabir se čuva u profilu potrošača.</small>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="form-pugi">
            {finishing && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <div className="surface-card border-round shadow-4 p-4 flex flex-column align-items-center gap-3" style={{ minWidth: '20rem' }}>
                        <ProgressSpinner style={{ width: '4rem', height: '4rem' }} strokeWidth="4" />
                        <div className="text-900 font-medium">{watch('poslati_izvestaj_email') ? 'Zavrsavanje naloga i slanje emaila je u toku...' : 'Zavrsavanje naloga je u toku...'}</div>
                        <small className="text-600">Molimo sacekajte.</small>
                    </div>
                </div>
            )}
            <Toast ref={toast} />
            <div className="surface-card border-round shadow-2 p-4 min-h-full">
                <div className="grid">
                    <div className="col-12 ">
                        <span className="text-900 text-xl font-medium mb-4 block flex align-items-center justify-content-between">
                            {i18n.t('pugi.model')} {id && `#${id}`}
                            <span className="mr-2 mb-2 flex align-items-center gap-2">
                                {watch('stranka_ne_omogucava_pregled') && <Tag value="Stranka ne omogućava pregled" severity="danger" icon="pi pi-ban" />}
                                {model && statusTemplate(model)}
                            </span>
                        </span>
                        <div className="mb-4">
                            <div className="flex align-items-center justify-content-between mb-1">
                                <small className="text-600">
                                    Korak {activeIndex + 1} / {stepDefinitions.length}
                                </small>
                                <small className="text-600">{stepDefinitions[activeIndex]}</small>
                            </div>
                            <ProgressBar value={Math.round(((activeIndex + 1) / stepDefinitions.length) * 100)} showValue={false} style={{ height: '6px' }} />
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)} style={{ paddingBottom: '6rem' }}>
                            {renderStepContent()}
                            <div className="pkgp-action-bar fixed bottom-0 left-0 right-0 w-full flex flex-wrap gap-2 justify-content-between align-items-center surface-card border-top-1 surface-border p-3" style={{ zIndex: 100 }}>
                                <Button type="button" label="Nazad" size="large" icon="pi pi-angle-left" outlined onClick={goPrev} />

                                <CanAccess module="pugi" action="start">
                                    {statusChange === 1 && !getValues('potrosac_nije_kuci') && !getValues('stranka_ne_omogucava_pregled') && (
                                        <StartButton module="pugi" disabled={!getValues('mm_id') || !canStartPugi()} size="large" label={i18n.t('start_check')} type="submit" onClick={() => setActionType('start')} />
                                    )}
                                    {statusChange === 1 && (getValues('potrosac_nije_kuci') || getValues('stranka_ne_omogucava_pregled')) && (
                                        <Button type="submit" size="large" icon="pi pi-save" severity="info" label={i18n.t('save') || 'Sačuvaj'} onClick={() => setActionType('save_exit')} disabled={!getValues('mm_id')} />
                                    )}
                                </CanAccess>

                                <CanAccess module="pugi" action="end">
                                    {statusChange === 2 && activeIndex === stepDefinitions.length - 1 && isInstallationFilled() && hasSignature() && (
                                        <EndButton module="pugi" disabled={getValues('potrosac_nije_kuci') || !canEndPugi()} size="large" label={i18n.t('end_check')} type="submit" onClick={() => setActionType('end')} />
                                    )}
                                </CanAccess>

                                {activeIndex < stepDefinitions.length - 1 && !(activeIndex === 1 && statusChange === 1) && !(activeIndex === 0 && statusChange === 1) && (
                                    <Button type="button" size="large" label={saving ? 'Čuvanje...' : 'Dalje'} iconPos="right" icon={saving ? 'pi pi-spin pi-spinner' : 'pi pi-angle-right'} onClick={goNext} disabled={saving} />
                                )}
                                {statusChange === 3 && <Button outlined icon={<FontAwesomeIcon icon={faBackward} className="mr-2" />} size="large" label={i18n.t('back_to_list')} type="submit" onClick={() => setActionType('back')} />}

                                {/* <CanAccess module="pugi" action="delete">
                                    {statusChange === 1 && (
                                        <DeleteButton module="pugi" disabled={statusChange !== 1 || !canDeletePugi()} outlined size="large" type="button" onClick={() => confirmDeleteModel()}>
                                            <span className="hidden md:block ml-2">{i18n.t('delete')}</span>
                                        </DeleteButton>
                                    )}
                                </CanAccess> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Dialog visible={deleteModelDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Potvrdi" modal footer={deleteModelDialogFooter} onHide={hideDeleteModelDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {model && (
                        <span>
                            {i18n.t('delete_confirmation')} <b>{model.naziv}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
            <Dialog visible={mmSelectDialog} style={{ width: '80rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={false} modal onHide={() => setMmSelectDialog(false)}>
                <MmSelect
                    onAfterSelect={(selectedModel) => {
                        onSelectMM(selectedModel);
                    }}
                />
            </Dialog>
            <Dialog
                visible={signatureDialog}
                style={{ width: '100rem', padding: 0, maxWidth: '100vw' }}
                contentStyle={{ padding: 0, height: '90vh', maxWidth: '100%', overflow: 'hidden' }}
                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                header={false}
                modal
                maximizable
                onHide={() => setSignatureDialog(false)}
            >
                <SignaturePad onSaveImage={onSignature} />
            </Dialog>
            <Dialog header={'Bar kod čitač'} visible={showQrScaner} style={{ minWidth: '24rem' }} onHide={() => setShowQrScaner(false)}>
                <QrScaner
                    onScane={onScanneHandler}
                    onClose={() => {
                        setShowQrScaner(false);
                    }}
                ></QrScaner>
            </Dialog>
            <Dialog header="UGI skica" visible={previewDialog.visible} style={{ width: '95vw' }} breakpoints={{ '960px': '95vw', '641px': '100vw' }} modal onHide={hidePreviewDialog}>
                {previewDialog.file ? (
                    <div className="flex flex-column gap-3" style={{ minHeight: '60vh' }}>
                        <div className="flex gap-2 align-items-center flex-wrap">
                            <Button icon="pi pi-search-minus" rounded outlined onClick={zoomOut} disabled={pdfScale <= 0.6} />
                            <Button icon="pi pi-refresh" rounded outlined onClick={resetZoom} disabled={Math.abs(pdfScale - 1) < 0.05} />
                            <Button icon="pi pi-search-plus" rounded outlined onClick={zoomIn} disabled={pdfScale >= 3} />
                            <Button icon="pi pi-external-link" text onClick={() => previewFileUrl && window.open(previewFileUrl, '_blank', 'noopener')} disabled={!previewFileUrl}>
                                Otvori u novom prozoru
                            </Button>
                        </div>
                        <div ref={previewContainerRef} style={{ overflowY: 'auto', maxHeight: '70vh' }}>
                            {previewError && (
                                <div className="text-red-500">
                                    <p>Greška pri učitavanju dokumenta.</p>
                                    <small>{previewError.message || 'Nepoznata greška'}</small>
                                </div>
                            )}
                            {!previewError && (
                                <Document
                                    file={{
                                        url: previewDialog.file,
                                        httpHeaders: {
                                            Accept: 'application/pdf'
                                        },
                                        withCredentials: false
                                    }}
                                    onLoadSuccess={({ numPages }) => setPreviewNumPages(numPages)}
                                    onLoadError={(error) => {
                                        console.error('PDF load error:', error);
                                        setPreviewError(error);
                                    }}
                                    loading={
                                        <div className="flex justify-content-center py-5">
                                            <ProgressSpinner strokeWidth="4" style={{ width: '3rem', height: '3rem' }} />
                                        </div>
                                    }
                                    options={{
                                        cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
                                        cMapPacked: true,
                                        standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`
                                    }}
                                >
                                    {previewNumPages > 0
                                        ? Array.from({ length: previewNumPages }, (_, index) => (
                                              <Page key={`pugi-preview-page-${index + 1}`} pageNumber={index + 1} scale={pdfScale} width={previewWidth ? Math.min(previewWidth, 900) : undefined} renderMode="canvas" />
                                          ))
                                        : null}
                                </Document>
                            )}
                        </div>
                    </div>
                ) : (
                    <p>Dokument nije dostupan.</p>
                )}
            </Dialog>
            {/* <pre>{JSON.stringify(model, null, 2)}</pre> */}
        </div>
    );
}

export default PugiStepsForm;
